// components/voice/PTTSuggestionPopup.tsx
import { Volume2, Radio, Mic } from 'lucide-react';

interface PTTSuggestionPopupProps {
  onChoosePTT: () => void;
  onChooseOpenMic: () => void;
  translations: {
    noisy_environment: string;
    noisy_hint: string;
    use_ptt: string;
    open_mic: string;
  };
}

export function PTTSuggestionPopup({
  onChoosePTT,
  onChooseOpenMic,
  translations,
}: PTTSuggestionPopupProps) {
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in">
      <div className="bg-card border border-primary/20 rounded-2xl shadow-2xl p-6 mx-4 max-w-sm animate-scale-in">
        <div className="text-center mb-6">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
            <Volume2 className="w-8 h-8 text-primary" />
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">
            {translations.noisy_environment}
          </h3>
          <p className="text-sm text-muted-foreground">
            {translations.noisy_hint}
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={onChoosePTT}
            className="w-full py-3 px-4 bg-primary text-white rounded-xl font-medium hover:bg-primary/90 transition-all flex items-center justify-center gap-2"
          >
            <Radio className="w-5 h-5" />
            {translations.use_ptt}
          </button>
          <button
            onClick={onChooseOpenMic}
            className="w-full py-3 px-4 bg-muted text-foreground rounded-xl font-medium hover:bg-muted/80 transition-all flex items-center justify-center gap-2"
          >
            <Mic className="w-5 h-5" />
            {translations.open_mic}
          </button>
        </div>

        <p className="text-xs text-muted-foreground text-center mt-4">
          Je kunt dit later wijzigen met de <Radio className="w-3 h-3 inline" /> knop
        </p>
      </div>
    </div>
  );
}
